"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVehicleTypeFeeCoefficient = getVehicleTypeFeeCoefficient;
exports.getVehicleTypeFeeCoefficientOrDefault = getVehicleTypeFeeCoefficientOrDefault;
exports.getVehicleTypeFeeCoefficientFromVehicleTypeCosts = getVehicleTypeFeeCoefficientFromVehicleTypeCosts;
exports.getDefaultFeeCoefficient = getDefaultFeeCoefficient;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const legacy_models_1 = require("@daytrip/legacy-models");
const utils_1 = require("@daytrip/utils");
function getVehicleTypeFeeCoefficient(pricingArea, vehicleType) {
    return pricingArea instanceof legacy_models_1.Region
        ? getVehicleTypeFeeCoefficientFromVehicleTypeCosts(pricingArea.vehicleTypeCosts, vehicleType, pricingArea._id, undefined)
        : getVehicleTypeFeeCoefficientFromVehicleTypeCosts(pricingArea.vehicleTypeCosts, vehicleType, undefined, pricingArea._id);
}
function getVehicleTypeFeeCoefficientOrDefault(pricingArea, vehicleType) {
    try {
        return getVehicleTypeFeeCoefficient(pricingArea, vehicleType);
    }
    catch (error) {
        return getDefaultFeeCoefficient(pricingArea);
    }
}
function getVehicleTypeFeeCoefficientFromVehicleTypeCosts(vehicleTypeCosts, vehicleType, pricingRegionId, pricingCountryId) {
    const vehicleTypeCost = vehicleTypeCosts.find((cost) => cost.vehicleType === vehicleType);
    if (!vehicleTypeCost || (0, utils_1.isUndefinedOrNull)(vehicleTypeCost.feeCoefficient)) {
        throw new Error(`Vehicle costs not defined for vehicle type ${vehicleType} in pricing ${pricingRegionId ? "region" : "country"} ${pricingRegionId ?? pricingCountryId}`);
    }
    return vehicleTypeCost.feeCoefficient;
}
function getDefaultFeeCoefficient(pricingArea) {
    return getVehicleTypeFeeCoefficient(pricingArea, legacy_enums_1.VehicleType.Sedan);
}
//# sourceMappingURL=getVehicleTypeFeeCoefficient.js.map